import { useRootStore } from "store";
import { SubMenuItemType } from "models/header/menuItems";

/**
 * Custom hook to generate secondary menu items based on user type, customer state, and other conditions.
 * This logic is shared between Header and SecondaryMenu components to avoid duplication.
 */
export function useSecondaryMenuItems(): SubMenuItemType[] {
  const { user } = useRootStore((state) => state);
  const { workingCustomer: customer } = useRootStore(
    (state) => state.customers
  );
  const { inventory } = useRootStore((state) => state);
  const { unreadThreads, unhandledUploads } = useRootStore(
    (state) => state.status
  );

  const { isLoading: isLoadingCustomer, customerNumber } = customer;
  const isInternalUser = user.userInfo && user.userInfo.type === "Internal";

  const menuItems: SubMenuItemType[] = [
    {
      title: "Översikt",
      href: "/dashboard",
      notice: null,
      text: !isInternalUser
        ? "På översikten hittar du dina senaste händelser."
        : "På Översikten hittar du nya händelser på kunden, samt länkar till digitala tjänster och kundinställningar.",
      disabled: !customerNumber && !isLoadingCustomer
    },
    {
      title: "Inkorg",
      href: "/inbox",
      count: unreadThreads,
      notice: null,
      text: "I Inkorgen kan du läsa meddelanden i konversationer och svara på dem, starta nya konversationer och se vilka meddelanden du har skickat.",
      disabled: !customerNumber && !isLoadingCustomer
    },
    {
      title: "Dokumentarkiv",
      href: "/archive",
      notice: null,
      iconFontSize: "21px",
      text: !isInternalUser
        ? "I Dokumentarkivet lagras allt material."
        : "I Dokumentarkivet ska du lagra kundens material. ",
      disabled: !customerNumber && !isLoadingCustomer
    },
    {
      title: !isInternalUser ? "Leverera" : "Inleveranser",
      href: "/delivery",
      count: unhandledUploads,
      notice: null,
      text: !isInternalUser
        ? ""
        : "I Inleveranser finns de inlevererade dokument och filer som kunden laddat upp i MittKontor.",
      disabled: !customerNumber && !isLoadingCustomer
    }
  ];

  const showInventoryMenu =
    !!isInternalUser || inventory.inventories.length > 0;

  if (showInventoryMenu) {
    const showInventoryNotice =
      !isInternalUser &&
      !inventory.inventories.every((i) => i.state_name === "completed");

    menuItems.push({
      title: "Inventera",
      href: "/inventory",
      notice: showInventoryNotice ? "!" : null,
      text: "Inventera"
    });
  }

  if (isInternalUser) {
    menuItems.push({
      title: "Ludvig Skicka",
      href: "/documents",
      notice: null,
      text: "Ludvig Skicka"
    });
  }

  return menuItems;
}
